export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/wxc-lottery-rain/index.js